import { computed, get } from '@ember/object';
import { isNone } from '@ember/utils';
import { pctChg } from 'cio/helpers/cio-math';

export default function computedChange(key, a = 'originalMetric', b = 'metric') {
  let previous = `${a}.${key}`;
  let current = `${b}.${key}`;

  return computed(previous, current, function () {
    let change = pctChg(get(this, previous), get(this, current));

    if (isNone(change)) {
      return 0;
    }

    return change;
  });
}
